export enum StoreCarouselImageType {
  CAROUSEL_IMAGE = 'carousel_image',
  PRODUCT_IMAGE = 'product_image',
}

type StoreCarouselDataBase = {
  id: number;
  title: string;
  is_active: boolean;
  ordering: number;
  created_at: string;
  updated_at: string;
};

export type StoreCarouselData =
  | (StoreCarouselDataBase & {
      carousel_image_type: StoreCarouselImageType.CAROUSEL_IMAGE;
      image: string;
      product?: never;
    })
  | (StoreCarouselDataBase & {
      carousel_image_type: StoreCarouselImageType.PRODUCT_IMAGE;
      product: {
        id: number;
        product_image: string;
      };
      image?: never;
    });

type CreateStoreCarouselPayloadBase = {
  title: string;
  is_active: boolean;
};

export type CreateStoreCarouselPayload =
  | (CreateStoreCarouselPayloadBase & {
      image: File;
      product?: never;
    })
  | (CreateStoreCarouselPayloadBase & {
      product: number;
      image?: never;
    });

// PATCH /store/carousels/:id/   (multipart/form-data)
export interface UpdateStoreCarouselPayload {
  title?: string;
  image?: File | null;
  product?: number | null;
  ordering?: number;
  is_active?: boolean;
}

export interface ReorderStoreCarouselPayload {
  ordered_ids: number[];
}

export interface GetStoreCarouselListParams {
  store_id?: string;
}
